const ToggleButton = ({
  isExpanded,
  toggleExpand,
}: {
  isExpanded: boolean;
  toggleExpand: () => void;
}) => {
  return (
    <button
      onClick={toggleExpand}
      className="text-[#18988B] hover:text-[#027167] transition-colors text-sm font-medium"
    >
      {isExpanded ? (
        <span className="flex items-center gap-1">접기</span>
      ) : (
        <span className="flex items-center gap-1">더보기</span>
      )}
    </button>
  );
};

export default ToggleButton;
